<template>

    <!--~~~~~     PAGE FOOTER     ~~~~~-->
    <footer class="page-layout__footer  page-footer">

        <div class="page-footer__copyright">
            Разработчик: <a href="https://infocom.kg/">Государственное предприятие «Инфоком»</a> <br>
            © Зарегистрирован в Государственном реестре программ для ЭВМ Кыргызской Республики от 26.09.2018 года, сертификат за № 525
        </div>

    </footer>
    <!--~~~~~     / PAGE FOOTER     ~~~~~-->
</template>

<script>
    export default {
        name: "AdminFooter"
    }
</script>

<style scoped>

</style>